import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Image from "../images/hero_1.jpg";
import Avatar from "@mui/material/Avatar";
import Footer from "../component/Footer";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "../axios/axios";
import { useNavigate } from "react-router-dom";
import { userProfileAction } from "../redux/actions/userAction";
import { useDispatch } from "react-redux";

function EditProfile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [position, setPosition] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, seConfirmPassword] = useState("");

  const [profilePic, setProfilePic] = useState("");
  const { userInfo } = useSelector((state) => state.signIn);

  useEffect(() => {
    setUsername(userInfo.user.username);
    setEmail(userInfo.user.email);
    setDescription(userInfo.user.whoami);
    setPosition(userInfo.user.position);
    setProfilePic(userInfo.user.profilePic.url);
  }, []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      setProfilePic(event.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleChanges = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Password Mismatch", { position: "bottom-right" });
      return;
    }
    try {
      const { data } = await axios.patch("/api/user/updateInfo", {
        username: username,
        email: email,
        whoami: description,
        position: position,
        profilePic: profilePic,
      });
      toast.success("Your profile update successfully", {
        position: "bottom-right",
      });
      // Retrieve the current data stored in local storage
      let d = JSON.parse(localStorage.getItem("userInfo"));

      // Modify the "user" part of the data
      d.user = data.data;
      d.user.profilePic.url = data.data.profilePic.url;
      // Store the modified data back into local storage
      localStorage.setItem("userInfo", JSON.stringify(d));
      dispatch(userProfileAction());
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <section
        className="section-hero overlay inner-page bg-image"
        style={{
          backgroundImage: `url(${Image})`,
        }}
        id="home-section"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <h1 className="text-white font-weight-bold">Edit Profile</h1>
              <div className="custom-breadcrumbs">
                <Link to="/" style={{ color: 'white' }}>Home</Link> <span className="mx-2 slash">/</span>
                <span className="text-white">
                  <strong>Edit Profile</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="site-section" id="next-section">
        <div className="contain-edit">
          <div className="row">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <form onSubmit={handleChanges}>
                <div className="contain-grid">
                  <div className="profile-container">
                    <label htmlFor="file-upload">
                      <Avatar
                        alt="Profile Picture"
                        src={profilePic || "default-profile-picture.jpg"}
                        sx={{ width: 100, height: 100, cursor: "pointer" }}
                      />
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept="image/*"
                      name="profile_picture"
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                      multiple={false}
                    />
                    {userInfo.user.type === "businessman" && (
                      <div className="companyStatus">
                        <label htmlFor="company">Company status : </label>
                        {userInfo.user.pending === true ? (
                          <label
                            htmlFor="companyStatus"
                            style={{ color: "red" }}
                          >
                            {" "}
                            pending...
                          </label>
                        ) : (
                          <label
                            htmlFor="companyStatus"
                            style={{ color: "rgb(8, 189, 8)" }}
                          >
                            {" "}
                            Accepted
                          </label>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="changeUser left1">
                    <label htmlFor="username">Change Username</label>
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      placeholder="Enter new Username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>

                  <div className="changeUser left2">
                    <label htmlFor="username">Change Position</label>
                    <input
                      type="text"
                      id="position"
                      className="form-control"
                      placeholder="Enter new Position"
                      value={position}
                      onChange={(e) => setPosition(e.target.value)}
                    />
                  </div>
                  <div className="changeUser left3">
                    <label htmlFor="username">Change email</label>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      placeholder="Enter new Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="changeUser right1">
                    <label htmlFor="username">Change Description</label>
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      placeholder="Enter your new description"
                      value={description}
                      onChange={(e) => e.target.value}
                    />
                  </div>
                  <div className="changeUser right2">
                    <label htmlFor="username">New Password</label>
                    <input
                      type="password"
                      id="password"
                      className="form-control"
                      placeholder="Enter your new password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="changeUser right3">
                    <label htmlFor="username">Confirm Password</label>
                    <input
                      type="password"
                      id="password"
                      className="form-control"
                      placeholder="Confirm your new password"
                      value={confirmPassword}
                      onChange={(e) => seConfirmPassword(e.target.value)}
                    />
                  </div>
                  <div className="changeButton">
                    <button
                      type="submit"
                      className="btn btn-primary btn-md text-white"
                      style={{
                        backgroundColor: "blue",
                        border: "none",
                        marginLeft: "10px",
                      }}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default EditProfile;
